<template>
  <div class="error-popup" v-show="popupActive">
    <vs-popup class="error-popup-window"  :title="title" :active.sync="popupActive" color="#2d9cdb">
      <p>{{errorMessage}}</p>
      <div v-for="(error, index) in validationErrors" :key="index">
        <p>{{error.label}}：{{error.message}}</p>
      </div>
      <div class="button-area">
        <vs-button class="popup-button" color="#2d9cdb" @click="popupActive = false">OK</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>

export default {
  data() {
    return {
      title: "",
      isValidationError: false,
      validationErrors: [],
      errorMessage: "",
      popupActive: false
    }
  },
  methods: {
    open(title, errorMessage, validationErrors) {
      this.title = title
      this.errorMessage = errorMessage
      this.validationErrors = validationErrors
      this.popupActive = true
    }
  }
}
</script>

<style lang="scss">
.error-popup-window {
  .button-area {
    margin-top: 20px;
  }
  .popup-button {
    margin-left: auto;
    display: block;
  }
}
</style>
